module.exports = __webpack_public_path__ + "img/indexHR-banner.259510c8.png";